//frontend/src/modules/api.js
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

export const API_BASE_URL = 'http://127.0.0.1:8000/api/v1';

// ساخت یک نمونه axios برای استفاده در کل برنامه
const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// ✅✅✅ این بخش بسیار مهم است (Interceptor) ✅✅✅
// این قطعه کد قبل از ارسال هر درخواست اجرا می‌شود
axiosInstance.interceptors.request.use(async req => {
    let accessToken = localStorage.getItem('accessToken');
    
    if (accessToken) {
        const decodedToken = jwtDecode(accessToken);
        const isExpired = decodedToken.exp * 1000 < Date.now();

        if (!isExpired) {
            req.headers.Authorization = `Bearer ${accessToken}`;
            return req;
        }

        // اگر توکن منقضی شده بود، تلاش برای تمدید آن
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
            try {
                const response = await axios.post(`${API_BASE_URL}/auth/refresh/`, { refresh: refreshToken });
                accessToken = response.data.access;

                localStorage.setItem('accessToken', accessToken);
                req.headers.Authorization = `Bearer ${accessToken}`;
                return req;

            } catch (error) {
                console.error("Refresh token failed, logging out.", error);
                // اگر تمدید ناموفق بود، کاربر را از سیستم خارج کن
                localStorage.clear();
                window.location.href = '/'; 
                return Promise.reject(error);
            }
        }
    }
    return req;
});


// تابع کمکی برای هدرها (برای موارد خاص)
export const getAuthHeaders = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
        return {};
    }
    return {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        }
    };
};

// ✅ از این به بعد، در تمام فایل‌ها از axiosInstance استفاده کنید
export default axiosInstance;